// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trims_styles[data-v-de1fb6d8] {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.trims_style_card h4[data-v-de1fb6d8] {
  font-size: 55px;
  opacity: 0.5;
  line-height: 1;
}
.trims_style_card.disabledContent[data-v-de1fb6d8] {
  pointer-events: none !important;
  opacity: 0.9 !important;
}
.trims_style_card .cursor_pointer[data-v-de1fb6d8] {
  cursor: pointer;
}
.trims_style_card small[data-v-de1fb6d8] {
  font-size: 15px;
  display: block;
  min-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiTrims.vue","webpack://./AiTrims.vue"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,aAAA;EACA,qCAAA;ACAF;ADGA;EAII,eAAA;EACA,YAAA;EACA,cAAA;ACJJ;ADQE;EACE,+BAAA;EACA,uBAAA;ACNJ;ADNA;EAgBI,eAAA;ACPJ;ADTA;EAoBI,eAAA;EACA,cAAA;EACA,gBAAA;ACRJ","sourcesContent":["\n.trims_styles {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n\n.trims_style_card {\n\n\n  h4 {\n    font-size: 55px;\n    opacity: 0.5;\n    line-height: 1;\n  }\n\n\n  &.disabledContent {\n    pointer-events: none !important;\n    opacity: 0.9 !important;\n  }\n\n  .cursor_pointer {\n    cursor: pointer;\n  }\n\n  small {\n    font-size: 15px;\n    display: block;\n    min-height: 20px;\n  }\n\n}\n",".trims_styles {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n.trims_style_card h4 {\n  font-size: 55px;\n  opacity: 0.5;\n  line-height: 1;\n}\n.trims_style_card.disabledContent {\n  pointer-events: none !important;\n  opacity: 0.9 !important;\n}\n.trims_style_card .cursor_pointer {\n  cursor: pointer;\n}\n.trims_style_card small {\n  font-size: 15px;\n  display: block;\n  min-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
